import { render, staticRenderFns } from "./schoolClassList.vue?vue&type=template&id=45407768&scoped=true&"
import script from "./schoolClassList.js?vue&type=script&lang=js&"
export * from "./schoolClassList.js?vue&type=script&lang=js&"
import style0 from "./schoolClassList.vue?vue&type=style&index=0&id=45407768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45407768",
  null
  
)

export default component.exports